import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor";
var wxsModules = {};
global.currentModuleId = "_1bb93227";
global.currentSrcMode = "wx";
global.currentInject = { "moduleId": "_1bb93227" };
/** script content **/
require("./rate.ts?ctorType=component&index=0&isComponent&lang=ts&mpx&outputPath=components%2Findex1bb93227%2Findex&resourcePath=%2Fhome%2Frunner%2Fwork%2Fmpx-cube-ui%2Fmpx-cube-ui%2Fpackages%2Fmpx-cube-ui%2Fsrc%2Fcomponents%2Frate%2Findex.mpx&type=script");
export default processComponentOption({
    option: global.__mpxOptionsMap["_1bb93227"],
    ctorType: "component",
    outputPath: "components/index1bb93227/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: { 'rate-item': getComponent(require("./rate-item.mpx?isComponent&outputPath=components%2Frate-itemf29d1196%2Findex")) },
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
});
